import { createStyles, makeStyles } from '@material-ui/core';

const styles = () => createStyles({
  title: {
    fontSize: '28px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  container: {
    marginTop: '50px',
  },
  cellLastWidth: {
    maxWidth: '100px',
  },
});

const useStyles = makeStyles(styles);

export default useStyles;
